import * as React from "react";
function SvgMenuOpen(props) {
  return <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M14 4.333H2V3h12v1.333zm0 4.334H7.333V7.333H14v1.334zM2 13h12v-1.333H2V13zm2.705-7a.333.333 0 01.515.28v3.303a.333.333 0 01-.515.28L2.152 8.211a.333.333 0 010-.56L4.705 6z" fill="#fff" /></svg>;
}
export default SvgMenuOpen;